export default class Constants {
  
    static BETSLIP_SIZE = 10;
    static REQUIRED_LOGIN = 'REQUIRED_LOGIN';
    static UNAVAILABLE = 'UNAVAILABLE';
    static INVALID_BET_ACCEPTANCE_TYPE = 'INVALID_BET_ACCEPTANCE_TYPE';
    static UNAVAILABLE_MESSAGE = 'Selection is currently unavailable.';
    static ODDS_CHANGE = 'ODDS_CHANGE';
    static ODDS_CHANGE_TO = 'Odds has been changed to';
    static BETSLIP_SIZE_MESSAGE = 'Maximum is 10 selections.';
    static RACE_CLOSE_MESSAGE = 'The race is closed.';
    static BETS_CONFIRMATION = 'BETS_CONFIRMATION';
    static VALIDATED_OK = 'OK';
    static VALIDATED_ERROR = 'ERROR';
    static MAX_ZERO_MESSAGE = 'MAX_ZERO_MESSAGE';
    static INVALID_MIN_STAKE = 'INVALID_MIN_STAKE';
    static INVALID_MAX_STAKE = 'INVALID_MAX_STAKE';
    static INVALID_MAX_MIN_STAKE = 'INVALID_MAX_MIN_STAKE'
    static INVALID_STAKE = 'INVALID_STAKE';
    static BETS_SUCCESS = 'BETS_SUCCESS';
    static SOCCER_ID = 29;
    static BASKETBALL_ID = 4;
    static BASEBALL_ID = 3;
    static TENNIS_ID = 33;
    static HORSE_RACING_ID = 1000;
    static FOOTBALL_ID = 15;
    static HOCKEY_ID = 19;
    static VIRTUAL_HORSES_ID = 20;
    static VIRTUAL_DOGS_ID = 59;
    static ESPORT_ID = 12;
    static OUTRIGHT_ID = 100;
    static MIX_PARLAY_ID = 200;
    static VIRTUAL_SPORTS_ID = 300;
    static OUTRIGHT = 'Outright';
    static MIX_PARLAY = 'MixParlay';
    static TEASERS = 'Teasers';
    static CORRECT_SCORE = 'CorrectScore';
    static WHITE_SPACE = ' ';
    static HYPHEN_SYMBOL = '-';
    static OUTRIGHT_BET_TYPE = 99;
    static DEFAULT_SPORT_NAME = 'Soccer';
    static SCROLL_FROM_TOP = 50;
    static VIEW_OPTIONS_FROM_TOP = 42;
    static NAVIGATION_BORDER_BOTTOM_ON_CHROME = 5;
    static BET_STOPPED = 'BET_STOPPED';
    static VIRTUAL_SOCCER_NATIONS_CUP = 'Virtual Soccer Nations Cup';
    static VIRTUAL_SOCCER_LEAGUE = 'Virtual Soccer League';
    static VIRTUAL_BASKETBALL = 'Virtual Basketball';
    static VIRTUAL_TENNIS = 'Virtual Tennis';
    static VIRTUAL_HORSES = 'Virtual Horses';
    static VIRTUAL_DOGS = 'Virtual Dogs';
    static VIRTUAL_SOCCER_EURO_CUP = 'Virtual Soccer Euro Cup';
    static VIRTUAL_SOCCER_WORLD_CUP = 'Virtual Soccer World Cup';
    static VIRTUAL_SPORTS = 'Virtual Sports';
    static INTERNAL_SERVER_ERROR = 'Internal Server Error'
    static EVENTS_PER_EARLY_PAGE = 25;
    static UNIT_REGULAR = 'Regular';
    static UNIT_SET = 'Sets';
    static UNIT_GAMES = 'Games';
    static SPROTS_BETTING_ID ='sports-betting'
    static TAB_ITEMS = {
       SINGLE: 'single',
       PARLAY: 'parlay',
       TEASERS: 'teasers'
    }
    static MINI_HEADER_HEIGHT = 73;
    static MAX_VALUE_STAKE = 999999999;
    static ODDS_SELECTION_TYPE = {
        NORMAL: 'NORMAL',
        OUTRIGHT: 'OUTRIGHT'
    }
    static LANDING_PAGE_URL = '/en/';
    static PROMOTION_TYPE = {
      CASHBACK: 'CASHBACK',
      REBATE: 'REBATE',
      DEPOSIT: 'DEPOSIT',
      RELOAD: 'RELOAD',
      FREE: 'FREE',
      REWARD: 'REWARD'
    }
    static BET_ACTIONS = {
      BET_ACCEPTED: 'BET_ACCEPTED',
      BET_REJECTED: 'BET_REJECTED',
      BET_PROCESSING: 'BET_PROCESSING'
    }

    static BET_STATUS = {
      ACCEPTED: 'ACCEPTED',
      PENDING_ACCEPTANCE: 'PENDING_ACCEPTANCE',
      PROCESSED_WITH_ERROR: 'PROCESSED_WITH_ERROR',
      INVALID_BET_ACCEPTANCE_TYPE: 'INVALID_BET_ACCEPTANCE_TYPE'
    }

    static HR_BET_STATUS = {
      REJECTED: 'REJECTED',
      PRICE_CHANGED: 'PRICE_CHANGED',
      ACCEPTED: 'ACCEPTED',
      PARTIAL: 'PARTIAL',
      LIMIT_LIABILITY: 'LIMIT_LIABILITY',
      INVALID_SELECTION: 'INVALID_SELECTION'
    }

    static HR_BET_REASON = {
      EVENT_CLOSED: 'Event Closed',
      PRICE_CHANGED: 'Prices have changed.'
    }

    static HR_MARKET_TYPE = {
      WIN: 'Win',
      PLACE: 'Place'
    }

    static WAGER_STATUS = {
      PENDING: 'PENDING',
      OPEN: 'OPEN',
      SETTLED: 'SETTLED', 
      CANCELLED: 'CANCELLED',
      DELETED: 'DELETED',
      REFUNDED: 'REFUNDED'
    }

    static STATUS_BET = {
      ACCEPTED: 'ACCEPTED',
      WIN: 'WIN',
      LOSS: 'LOSS',
      DRAW: 'DRAW',
      RUNNING: 'RUNNING',
    }
    
    static WAGER_CANCEL_STATUS = {
      MANUAL: 'MANUAL',
      REFUNDED: 'REFUNDED'
    }

    static PROMOTION_VALIDATION = {
      VALIDATE_WELCOME_BONUS: 'VALIDATE_WELCOME_BONUS',
      VALIDATE_REACTIVATION_BONUS: 'VALIDATE_REACTIVATION_BONUS',
      VALIDATE_CASHBACK_REBATE_BONUS: 'VALIDATE_CASHBACK_REBATE_BONUS',
    }
    
    static PROMOTION_CLAIM = {
      CLAIM_WELCOME_BONUS: 'CLAIM_WELCOME_BONUS',
      CLAIM_REACTIVATION_BONUS: 'CLAIM_REACTIVATION_BONUS',
      CLAIM_CASHBACK_REBATE: 'CLAIM_CASHBACK_REBATE' 
    }

    static CIRCLE_OPTION = {
      RED: 1,
      BLUE: 2,
      NONE: 0
    }

    static PROMOTION_SHOW_READ_MORE_SIZE = 57;
    static JACKPOT_INTERVAL_TIME = 15;
    static SIDE_BAR_INTERVAL_TIME = 15;
    static CASINO_LABEL = {
      HOT: "HOT",
      NEW: "NEW",
      JACKPOT: "JACKPOT",
      NONE: "NONE"
    }
    static COUNTRY_CODES = [
      {"name": "Afghanistan", "phone-code": "+93", "country-code": "AF"},
      {"name": "Albania", "phone-code": "+355", "country-code": "AL"},
      {"name": "Algeria", "phone-code": "+213", "country-code": "DZ"},
      {"name": "American Samoa", "phone-code": "+1-684", "country-code": "AS"},
      {"name": "Andorra", "phone-code": "+376", "country-code": "AD"},
      {"name": "Angola", "phone-code": "+244", "country-code": "AO"},
      {"name": "Anguilla", "phone-code": "+1-264", "country-code": "AI"},
      {"name": "Antarctica", "phone-code": "+672", "country-code": "AQ"},
      {"name": "Antigua and Barbuda", "phone-code": "+1-268", "country-code": "AG"},
      {"name": "Argentina", "phone-code": "+54", "country-code": "AR"},
      {"name": "Armenia", "phone-code": "+374", "country-code": "AM"},
      {"name": "Aruba", "phone-code": "+297", "country-code": "AW"},
      {"name": "Australia", "phone-code": "+61", "country-code": "AU"},
      {"name": "Austria", "phone-code": "+43", "country-code": "AT"},
      {"name": "Azerbaijan", "phone-code": "+994", "country-code": "AZ"},
      {"name": "Bahamas", "phone-code": "+1-242", "country-code": "BS"},
      {"name": "Bahrain", "phone-code": "+973", "country-code": "BH"},
      {"name": "Bangladesh", "phone-code": "+880", "country-code": "BD"},
      {"name": "Barbados", "phone-code": "+1-246", "country-code": "BB"},
      {"name": "Belarus", "phone-code": "+375", "country-code": "BY"},
      {"name": "Belgium", "phone-code": "+32", "country-code": "BE"},
      {"name": "Belize", "phone-code": "+501", "country-code": "BZ"},
      {"name": "Benin", "phone-code": "+229", "country-code": "BJ"},
      {"name": "Bermuda", "phone-code": "+1-441", "country-code": "BM"},
      {"name": "Bhutan", "phone-code": "+975", "country-code": "BT"},
      {"name": "Bolivia", "phone-code": "+591", "country-code": "BO"},
      {"name": "Bosnia and Herzegovina", "phone-code": "+387", "country-code": "BA"},
      {"name": "Botswana", "phone-code": "+267", "country-code": "BW"},
      {"name": "Brazil", "phone-code": "+55", "country-code": "BR"},
      {"name": "British Indian Ocean Territory", "phone-code": "+246", "country-code": "IO"},
      {"name": "British Virgin Islands", "phone-code": "+1-284", "country-code": "VG"},
      {"name": "Brunei", "phone-code": "+673", "country-code": "BN"},
      {"name": "Bulgaria", "phone-code": "+359", "country-code": "BG"},
      {"name": "Burkina Faso", "phone-code": "+226", "country-code": "BF"},
      {"name": "Burundi", "phone-code": "+257", "country-code": "BI"},
      {"name": "Cambodia", "phone-code": "+855", "country-code": "KH"},
      {"name": "Cameroon", "phone-code": "+237", "country-code": "CM"},
      {"name": "Canada", "phone-code": "+1", "country-code": "CA"},
      {"name": "Cape Verde", "phone-code": "+238", "country-code": "CV"},
      {"name": "Cayman Islands", "phone-code": "+1-345", "country-code": "KY"},
      {"name": "Central African Republic", "phone-code": "+236", "country-code": "CF"},
      {"name": "Chad", "phone-code": "+235", "country-code": "TD"},
      {"name": "Chile", "phone-code": "+56", "country-code": "CL"},
      {"name": "China", "phone-code": "+86", "country-code": "CN"},
      {"name": "Christmas Island", "phone-code": "+6189164", "country-code": "CX"},
      {"name": "Cocos Islands", "phone-code": "+6189162", "country-code": "CC"},
      {"name": "Colombia", "phone-code": "+57", "country-code": "CO"},
      {"name": "Comoros", "phone-code": "+269", "country-code": "KM"},
      {"name": "Cook Islands", "phone-code": "+682", "country-code": "CK"},
      {"name": "Costa Rica", "phone-code": "+506", "country-code": "CR"},
      {"name": "Croatia", "phone-code": "+385", "country-code": "HR"},
      {"name": "Cuba", "phone-code": "+53", "country-code": "CU"},
      {"name": "Curacao", "phone-code": "+599", "country-code": "CW"},
      {"name": "Cyprus", "phone-code": "+357", "country-code": "CY"},
      {"name": "Czech Republic", "phone-code": "+420", "country-code": "CZ"},
      {"name": "Democratic Republic of the Congo", "phone-code": "+243", "country-code": "CD"},
      {"name": "Denmark", "phone-code": "+45", "country-code": "DK"},
      {"name": "Djibouti", "phone-code": "+253", "country-code": "DJ"},
      {"name": "Dominica", "phone-code": "+1-767", "country-code": "DM"},
      {"name": "Dominican Republic", "phone-code": "+1-809", "country-code": "DO"},
      {"name": "Dominican Republic", "phone-code": "+1-829", "country-code": "DO"},
      {"name": "Dominican Republic", "phone-code": "+1-849", "country-code": "DO"},
      {"name": "East Timor", "phone-code": "+670", "country-code": "TL"},
      {"name": "Ecuador", "phone-code": "+593", "country-code": "EC"},
      {"name": "Egypt", "phone-code": "+20", "country-code": "EG"},
      {"name": "El Salvador", "phone-code": "+503", "country-code": "SV"},
      {"name": "Equatorial Guinea", "phone-code": "+240", "country-code": "GQ"},
      {"name": "Eritrea", "phone-code": "+291", "country-code": "ER"},
      {"name": "Estonia", "phone-code": "+372", "country-code": "EE"},
      {"name": "Ethiopia", "phone-code": "+251", "country-code": "ET"},
      {"name": "Falkland Islands", "phone-code": "+500", "country-code": "FK"},
      {"name": "Faroe Islands", "phone-code": "+298", "country-code": "FO"},
      {"name": "Fiji", "phone-code": "+679", "country-code": "FJ"},
      {"name": "Finland", "phone-code": "+358", "country-code": "FI"},
      {"name": "France", "phone-code": "+33", "country-code": "FR"},
      {"name": "French Polynesia", "phone-code": "+689", "country-code": "PF"},
      {"name": "Gabon", "phone-code": "+241", "country-code": "GA"},
      {"name": "Gambia", "phone-code": "+220", "country-code": "GM"},
      {"name": "Georgia", "phone-code": "+995", "country-code": "GE"},
      {"name": "Germany", "phone-code": "+49", "country-code": "DE"},
      {"name": "Ghana", "phone-code": "+233", "country-code": "GH"},
      {"name": "Gibraltar", "phone-code": "+350", "country-code": "GI"},
      {"name": "Greece", "phone-code": "+30", "country-code": "GR"},
      {"name": "Greenland", "phone-code": "+299", "country-code": "GL"},
      {"name": "Grenada", "phone-code": "+1-473", "country-code": "GD"},
      {"name": "Guam", "phone-code": "+1-671", "country-code": "GU"},
      {"name": "Guatemala", "phone-code": "+502", "country-code": "GT"},
      {"name": "Guernsey", "phone-code": "+44-1481", "country-code": "GG"},
      {"name": "Guinea", "phone-code": "+224", "country-code": "GN"},
      {"name": "Guinea-Bissau", "phone-code": "+245", "country-code": "GW"},
      {"name": "Guyana", "phone-code": "+592", "country-code": "GY"},
      {"name": "Haiti", "phone-code": "+509", "country-code": "HT"},
      {"name": "Honduras", "phone-code": "+504", "country-code": "HN"},
      {"name": "Hong Kong", "phone-code": "+852", "country-code": "HK"},
      {"name": "Hungary", "phone-code": "+36", "country-code": "HU"},
      {"name": "Iceland", "phone-code": "+354", "country-code": "IS"},
      {"name": "India", "phone-code": "+91", "country-code": "IN"},
      {"name": "Indonesia", "phone-code": "+62", "country-code": "ID"},
      {"name": "Iran", "phone-code": "+98", "country-code": "IR"},
      {"name": "Iraq", "phone-code": "+964", "country-code": "IQ"},
      {"name": "Ireland", "phone-code": "+353", "country-code": "IE"},
      {"name": "Isle of Man", "phone-code": "+44-1624", "country-code": "IM"},
      {"name": "Israel", "phone-code": "+972", "country-code": "IL"},
      {"name": "Italy", "phone-code": "+39", "country-code": "IT"},
      {"name": "Ivory Coast", "phone-code": "+225", "country-code": "CI"},
      {"name": "Jamaica", "phone-code": "+1-876", "country-code": "JM"},
      {"name": "Japan", "phone-code": "+81", "country-code": "JP"},
      {"name": "Jersey", "phone-code": "+44-1534", "country-code": "JE"},
      {"name": "Jordan", "phone-code": "+962", "country-code": "JO"},
      {"name": "Kazakhstan", "phone-code": "+7", "country-code": "KZ"},
      {"name": "Kenya", "phone-code": "+254", "country-code": "KE"},
      {"name": "Kiribati", "phone-code": "+686", "country-code": "KI"},
      {"name": "Kosovo", "phone-code": "+383", "country-code": "XK"},
      {"name": "Kuwait", "phone-code": "+965", "country-code": "KW"},
      {"name": "Kyrgyzstan", "phone-code": "+996", "country-code": "KG"},
      {"name": "Laos", "phone-code": "+856", "country-code": "LA"},
      {"name": "Latvia", "phone-code": "+371", "country-code": "LV"},
      {"name": "Lebanon", "phone-code": "+961", "country-code": "LB"},
      {"name": "Lesotho", "phone-code": "+266", "country-code": "LS"},
      {"name": "Liberia", "phone-code": "+231", "country-code": "LR"},
      {"name": "Libya", "phone-code": "+218", "country-code": "LY"},
      {"name": "Liechtenstein", "phone-code": "+423", "country-code": "LI"},
      {"name": "Lithuania", "phone-code": "+370", "country-code": "LT"},
      {"name": "Luxembourg", "phone-code": "+352", "country-code": "LU"},
      {"name": "Macau", "phone-code": "+853", "country-code": "MO"},
      {"name": "Macedonia", "phone-code": "+389", "country-code": "MK"},
      {"name": "Madagascar", "phone-code": "+261", "country-code": "MG"},
      {"name": "Malawi", "phone-code": "+265", "country-code": "MW"},
      {"name": "Malaysia", "phone-code": "+60", "country-code": "MY"},
      {"name": "Maldives", "phone-code": "+960", "country-code": "MV"},
      {"name": "Mali", "phone-code": "+223", "country-code": "ML"},
      {"name": "Malta", "phone-code": "+356", "country-code": "MT"},
      {"name": "Marshall Islands", "phone-code": "+692", "country-code": "MH"},
      {"name": "Mauritania", "phone-code": "+222", "country-code": "MR"},
      {"name": "Mauritius", "phone-code": "+230", "country-code": "MU"},
      {"name": "Mayotte", "phone-code": "+262", "country-code": "YT"},
      {"name": "Mexico", "phone-code": "+52", "country-code": "MX"},
      {"name": "Micronesia", "phone-code": "+691", "country-code": "FM"},
      {"name": "Moldova", "phone-code": "+373", "country-code": "MD"},
      {"name": "Monaco", "phone-code": "+377", "country-code": "MC"},
      {"name": "Mongolia", "phone-code": "+976", "country-code": "MN"},
      {"name": "Montenegro", "phone-code": "+382", "country-code": "ME"},
      {"name": "Montserrat", "phone-code": "+1-664", "country-code": "MS"},
      {"name": "Morocco", "phone-code": "+212", "country-code": "MA"},
      {"name": "Mozambique", "phone-code": "+258", "country-code": "MZ"},
      {"name": "Myanmar", "phone-code": "+95", "country-code": "MM"},
      {"name": "Namibia", "phone-code": "+264", "country-code": "NA"},
      {"name": "Nauru", "phone-code": "+674", "country-code": "NR"},
      {"name": "Nepal", "phone-code": "+977", "country-code": "NP"},
      {"name": "Netherlands", "phone-code": "+31", "country-code": "NL"},
      {"name": "Netherlands Antilles", "phone-code": "+599", "country-code": "AN"},
      {"name": "New Caledonia", "phone-code": "+687", "country-code": "NC"},
      {"name": "New Zealand", "phone-code": "+64", "country-code": "NZ"},
      {"name": "Nicaragua", "phone-code": "+81", "country-code": "NI"},
      {"name": "Niger", "phone-code": "+227", "country-code": "NE"},
      {"name": "Nigeria", "phone-code": "+234", "country-code": "NG"},
      {"name": "Niue", "phone-code": "+683", "country-code": "NU"},
      {"name": "Northern Mariana Islands", "phone-code": "+1-670", "country-code": "MP"},
      {"name": "North Korea", "phone-code": "+850", "country-code": "KP"},
      {"name": "Norway", "phone-code": "+47", "country-code": "NO"},
      {"name": "Oman", "phone-code": "+968", "country-code": "OM"},
      {"name": "Pakistan", "phone-code": "+92", "country-code": "PK"},
      {"name": "Palau", "phone-code": "+680", "country-code": "PW"},
      {"name": "Palestine", "phone-code": "+970", "country-code": "PS"},
      {"name": "Panama", "phone-code": "+507", "country-code": "PA"},
      {"name": "Papua New Guinea", "phone-code": "+675", "country-code": "PG"},
      {"name": "Paraguay", "phone-code": "+595", "country-code": "PY"},
      {"name": "Peru", "phone-code": "+51", "country-code": "PE"},
      {"name": "Philippines", "phone-code": "+63", "country-code": "PH"},
      {"name": "Pitcairn", "phone-code": "+64", "country-code": "PN"},
      {"name": "Poland", "phone-code": "+48", "country-code": "PL"},
      {"name": "Portugal", "phone-code": "+351", "country-code": "PT"},
      {"name": "Puerto Rico", "phone-code": "+1-787", "country-code": "PR"},
      {"name": "Puerto Rico", "phone-code": "+1-939", "country-code": "PR"},
      {"name": "Qatar", "phone-code": "+974", "country-code": "QA"},
      {"name": "Republic of the Congo", "phone-code": "+242", "country-code": "CG"},
      {"name": "Reunion", "phone-code": "+262", "country-code": "RE"},
      {"name": "Romania", "phone-code": "+40", "country-code": "RO"},
      {"name": "Russia", "phone-code": "+7", "country-code": "RU"},
      {"name": "Rwanda", "phone-code": "+250", "country-code": "RW"},
      {"name": "Saint Barthelemy", "phone-code": "+590", "country-code": "BL"},
      {"name": "Saint Helena", "phone-code": "+290", "country-code": "SH"},
      {"name": "Saint Kitts and Nevis", "phone-code": "+1-869", "country-code": "KN"},
      {"name": "Saint Lucia", "phone-code": "+1-758", "country-code": "LC"},
      {"name": "Saint Martin", "phone-code": "+590", "country-code": "MF"},
      {"name": "Saint Pierre and Miquelon", "phone-code": "+508", "country-code": "PM"},
      {"name": "Saint Vincent and the Grenadines", "phone-code": "+1-784", "country-code": "VC"},
      {"name": "Samoa", "phone-code": "+685", "country-code": "WS"},
      {"name": "San Marino", "phone-code": "+378", "country-code": "SM"},
      {"name": "Sao Tome and Principe", "phone-code": "+239", "country-code": "ST"},
      {"name": "Saudi Arabia", "phone-code": "+966", "country-code": "SA"},
      {"name": "Senegal", "phone-code": "+221", "country-code": "SN"},
      {"name": "Serbia", "phone-code": "+381", "country-code": "RS"},
      {"name": "Seychelles", "phone-code": "+248", "country-code": "SC"},
      {"name": "Sierra Leone", "phone-code": "+232", "country-code": "SL"},
      {"name": "Singapore", "phone-code": "+65", "country-code": "SG"},
      {"name": "Sint Maarten", "phone-code": "+1-721", "country-code": "SX"},
      {"name": "Slovakia", "phone-code": "+421", "country-code": "SK"},
      {"name": "Slovenia", "phone-code": "+386", "country-code": "SI"},
      {"name": "Solomon Islands", "phone-code": "+677", "country-code": "SB"},
      {"name": "Somalia", "phone-code": "+252", "country-code": "SO"},
      {"name": "South Africa", "phone-code": "+27", "country-code": "ZA"},
      {"name": "South Korea", "phone-code": "+82", "country-code": "KR"},
      {"name": "South Sudan", "phone-code": "+211", "country-code": "SS"},
      {"name": "Spain", "phone-code": "+34", "country-code": "ES"},
      {"name": "Sri Lanka", "phone-code": "+94", "country-code": "LK"},
      {"name": "Sudan", "phone-code": "+249", "country-code": "SD"},
      {"name": "Suriname", "phone-code": "+597", "country-code": "SR"},
      {"name": "Svalbard and Jan Mayen", "phone-code": "+47", "country-code": "SJ"},
      {"name": "Swaziland", "phone-code": "+268", "country-code": "SZ"},
      {"name": "Sweden", "phone-code": "+46", "country-code": "SE"},
      {"name": "Switzerland", "phone-code": "+41", "country-code": "CH"},
      {"name": "Syria", "phone-code": "+963", "country-code": "SY"},
      {"name": "Taiwan", "phone-code": "+886", "country-code": "TW"},
      {"name": "Tajikistan", "phone-code": "+992", "country-code": "TJ"},
      {"name": "Tanzania", "phone-code": "+255", "country-code": "TZ"},
      {"name": "Thailand", "phone-code": "+66", "country-code": "TH"},
      {"name": "Togo", "phone-code": "+228", "country-code": "TG"},
      {"name": "Tokelau", "phone-code": "+690", "country-code": "TK"},
      {"name": "Tonga", "phone-code": "+676", "country-code": "TO"},
      {"name": "Trinidad and Tobago", "phone-code": "+1-868", "country-code": "TT"},
      {"name": "Tunisia", "phone-code": "+216", "country-code": "TN"},
      {"name": "Turkey", "phone-code": "+90", "country-code": "TR"},
      {"name": "Turkmenistan", "phone-code": "+993", "country-code": "TM"},
      {"name": "Turks and Caicos Islands", "phone-code": "+1-649", "country-code": "TC"},
      {"name": "Tuvalu", "phone-code": "+688", "country-code": "TV"},
      {"name": "U.S. Virgin Islands", "phone-code": "+1340", "country-code": "VI"},
      {"name": "Uganda", "phone-code": "+256", "country-code": "UG"},
      {"name": "Ukraine", "phone-code": "+380", "country-code": "UA"},
      {"name": "United Arab Emirates", "phone-code": "+971", "country-code": "AE"},
      {"name": "United Kingdom", "phone-code": "+44", "country-code": "GB"},
      {"name": "United States", "phone-code": "+1", "country-code": "US"},
      {"name": "Uruguay", "phone-code": "+598", "country-code": "UY"},
      {"name": "Uzbekistan", "phone-code": "+998", "country-code": "UZ"},
      {"name": "Vanuatu", "phone-code": "+678", "country-code": "VU"},
      {"name": "Vatican", "phone-code": "+379", "country-code": "VA"},
      {"name": "Venezuela", "phone-code": "+58", "country-code": "VE"},
      {"name": "Vietnam", "phone-code": "+84", "country-code": "VN"},
      {"name": "Wallis and Futuna", "phone-code": "+681", "country-code": "WF"},
      {"name": "Western Sahara", "phone-code": "+212", "country-code": "EH"},
      {"name": "Yemen", "phone-code": "+967", "country-code": "YE"},
      {"name": "Zambia", "phone-code": "+260", "country-code": "ZM"},
      {"name": "Zimbabwe", "phone-code": "+263", "country-code": "ZW"}
  ];

  static MYBET_URL ="/account/{lang}/my-bets-full";

  static REFRESH_TIME = {
    HIGH_LIGHT: 60,
    LIVE: 20,
    NON_LIVE: 60
  }

  static ESPORT_ALL_GAMES_CODE = 'allGames'

  static ODDS_STATUS = {
    ODDS_CHANGE: 'ODDS_CHANGE'
  }

  static THOUSANDS_SEPARATOR = ','
  
  static BET_ERROR_CODE = {
    LINE_CHANGED: 'LINE_CHANGED',
    MAX_BET_EXCEEDED : 'MAX_BET_EXCEEDED',
    EVENT_OFFLINE: 'ERROR3105',
    ABOVE_MAX_BET_AMOUNT: 'ABOVE_MAX_BET_AMOUNT',
    BELOW_MIN_BET_AMOUNT: 'BELOW_MIN_BET_AMOUNT',
    ERROR3103: 'ERROR3103',
    ERROR3104: 'ERROR3104',
    INVALID_ROUND_ROBIN_OPTIONS: 'INVALID_ROUND_ROBIN_OPTIONS',
    OFFLINE_EVENT: 'OFFLINE_EVENT',
    INVALID_EVENT: 'INVALID_EVENT',
    CORRELATED: 'CORRELATED',
    CORRELATED_EXTRA_MESSAGE: 'CORRELATED_EXTRA_MESSAGE',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    MINIMUM_ROUND_ROBIN_OPTIONS: 'MINIMUM_ROUND_ROBIN_OPTIONS',
    EVENT_NOT_FOUND: 'EVENT_NOT_FOUND',
    BET_OFFLINE_EVENT: 'BET_OFFLINE_EVENT',
    ODDS_CHANGE: 'ODDS_CHANGE',
    ODDS_CHANGED: 'ODDS_CHANGED',
    BET_LINE_CHANGED: 'BET_LINE_CHANGED',
    UNAVAILABLE: 'UNAVAILABLE',
    RESPONSIBLE_LIMIT_EXCEEDED_RISK: 'RESPONSIBLE_LIMIT_EXCEEDED_RISK',
    RESPONSIBLE_LIMIT_EXCEEDED_LOSS: 'RESPONSIBLE_LIMIT_EXCEEDED_LOSS',
    RESPONSIBLE_LIMIT_EXCEEDED_RISK_WITH_MULTIPLE_BET:'RESPONSIBLE_LIMIT_EXCEEDED_RISK_WITH_MULTIPLE_BET',
    RESPONSIBLE_LIMIT_EXCEEDED_LOSS_WITH_MULTIPLE_BET: 'RESPONSIBLE_LIMIT_EXCEEDED_LOSS_WITH_MULTIPLE_BET',
    BETTING_BUDGET_EXCEEDED: 'BETTING_BUDGET_EXCEEDED',
    INVALID_ODDS_FORMAT: 'INVALID_ODDS_FORMAT',
    INVALID_BET_ACCEPTANCE_TYPE: 'INVALID_BET_ACCEPTANCE_TYPE',
    RESUBMIT_REQUEST: 'RESUBMIT_REQUEST',
    LINE_IS_NOT_AVAILABLE: 'LINE_IS_NOT_AVAILABLE',
    ROUND_ROBIN_DISALLOWED: "ROUND_ROBIN_DISALLOWED",
    ERROR3116: "ERROR3116",
    INVALID_LEGS: "INVALID_LEGS"
  }

  static WAGER_TYPE = {
    NORMAL: 'NORMAL',
    OUTRIGHT: 'OUTRIGHT',
    PARLAY: 'PARLAY',
    TEASERS: 'TEASERS'
  }

  static TEASER_ERROR = {
    TOO_MANY_LEGS: 'TOO_MANY_LEGS',
    TOO_FEW_LEGS: 'TOO_FEW_LEGS',
    POINTS_NO_LONGER_AVAILABLE: 'POINTS_NO_LONGER_AVAILABLE',
    EVENT_NOT_FOUND: 'EVENT_NOT_FOUND',
    OFFLINE_EVENT: 'OFFLINE_EVENT',
    INVALID_EVENT: 'INVALID_EVENT',
    LINE_CHANGED: 'LINE_CHANGED',
    BET_LINE_CHANGED: 'BET_LINE_CHANGED',
    LINE_IS_NOT_AVAILABLE: 'LINE_IS_NOT_AVAILABLE',
    BET_LINE_IS_NOT_AVAILABLE: 'BET_LINE_IS_NOT_AVAILABLE',
    POINT_CHANGE: 'POINT_CHANGE',
    SELECTION_POINT_CHANGED: 'SELECTION_POINT_CHANGED',
    SELECTION_UNAVALABLE: 'SELECTION_UNAVALABLE',
    UNAVAILABLE: 'UNAVAILABLE',
    SAME_GAME_DIFFERENT_PICK: 'SAME_GAME_DIFFERENT_PICK',
    MAX_TEASERS: 'MaxTeasers',
    MINIMUM_SELECTIONS_TEASER: 'MINIMUM_SELECTIONS_TEASER',
    SELECTING_PICK_DIFFERENT_SPORT: 'SELECTING_PICK_DIFFERENT_SPORT',
    SELECTING_PICK_DIFFERENT_TYPE: 'SELECTING_PICK_DIFFERENT_TYPE',
    SELECTING_PICK_DIFFERENT_POINT: 'SELECTING_PICK_DIFFERENT_POINT',
    INVALID_LEGS: 'INVALID_LEGS',
    BET_OFFLINE_EVENT: 'BET_OFFLINE_EVENT',
  }
  
  static MARKET_NAME = {
    PARLAY: 'PARLAY',
    OUTRIGHT: 'OUTRIGHT',
    CORRECT_SCORE: 'CORRECT_SCORE',
    SPECIALS: 'Specials',
    TEASERS: 'Teasers',
    DOUBLE_CHANCE: 'DOUBLE_CHANCE',
    ALL: 'All',
    WIN: 'Win',
    PLACE: 'Place'
  }

  static DEFAULT_LOCALE = 'en_US';
  static DEFAULT_TIME_ZONE = 'GMT-04:00';
  static SERVER_TIME_ZONE_ID = 'America/Curacao';
  
  static BETSLIP_FORMAT_DATE = 'YYYY-MM-DD'

  static VS_MESSAGE = {
    HEIGHT: 'height',
    ODDS_SELECTION: 'oddsSelection',
    IS_LOGIN: 'isLogin',
    ODDS_SELECTION_VALIDATE: 'oddsSelectionValidate',
    ODDS_SELECTION_PARLAY_VALIDATE: 'oddsSelectionParlayValidate',
    PLACE_BET: 'placeBet',
    PLACE_PARLAY_BET: 'placeParlayBet',
    ODDS_REFRESH: 'oddsRefresh',
    SELECTION_REMOVED: 'selectionRemoved',
    HIDE_UI_LOADING: 'hideUiLoading',
    CHANGE_ODDS_FORMAT: 'changeOddsFormat',
    GET_PARLAY_BET_SETTING_DONE: 'getParlayBetSettingDone',
    CHANGE_SPORT: 'changeSport',
    GET_USER_OPTIONS: 'getUserOptions',
    ODDS_SELECTION_ERROR: 'oddsSelectionError',
    NOTIFYMESSAGE: 'notifyMessage',
  }

  static HR_MESSAGE = {
    ODDS_SELECTION: 'betSlipEmit',
    IFRAM_INFO: 'infoEmit',
    LOGIN_STATUS: 'loginStatusEmit',
    TOKEN_INFO: 'tokenEmit',
    LATEST_ODDS: 'latestOddsEmit',
    ODDSFORMAT_UPDATED: 'oddsTypeEmit',
    ODDS_SELECTION_ERROR: 'betSlipErrorEmit',
    EVENT_CLOSED: 'betSlipRaceClosed',
  }

  static BB_MESSAGE = {
    LOGIN_REQUIRED: 'ds::login',
    IFRAME_INFO : 'ds::widgets::height',
    DS_BETSLIP : 'ds::betslip',
    DS_PLACE : 'ds::betbuilder::placed',
    READY: 'ds::ready',
    LOADED: 'ds::loaded'
  }
  
  static BB_ERROR = {
    API_DISABLE: "API_DISABLED"
  }

  static ODDS_SELECTION_ERRORS = {
    MAX_BETSLIP_SIZE: 'overTenBets',
    RACE_CLOSED: 'raceClosed'
  }

    static VS_ERROR = {
    INVALID: 'INVALID',
    VS_BET_STOPPED_STATUS: 'STOPPED',
    VS_BET_STARTED_STATUS: "STARTED",
    VS_BET_STOPPED_ERROR_CODE: 'BET_STOPPED',
    VS_PLACE_BET_SUCCESS_STATUS: "ACCEPTED",
    VS_PARLAY_INVALID_TICKET: 'PARLAY_INVALID_TICKET',
    VS_PARLAY_INVALID_MESSAGE: 'PARLAY_INVALID_MESSAGE',
    VS_EVENT_DUPLICATED: 'EVENT_DUPLICATED',
    BETTING_BUDGET_EXCEEDED: 'BETTING_BUDGET_EXCEEDED'
  }
  static SPORTNAME_SUB_TYPE_MATCH_WINNER = 37
  static VS_ODD_TYPE_BY_SKINS = ['isPS38', 'isGreen1', 'isDarkBlue3', 'isSkin4', 'isMMX', 'isP88', 'isPSP55', 'isSkin8', 'isBookielink']
  static NOTIFICATION_TYPE = {
    INFO: "INFO",
    WARNING: "WARNING",
    ERROR: "ERROR"
  }
  static DEFAULT_NOTIFICATION_DURATION = 5;
  static PRODUCT = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    MAINTENANCE: 'MAINTENANCE',
    CLOSED: 'CLOSED',
    WAGERING_SUSPENDED: 'WAGERING_SUSPENDED'
  }

  static DATE_FORMAT_YYYY_MMMM_D = 'YYYY MMMM Do, H:mm:ss';
  static DATE_FORMAT_YYYY_MMM_D = 'YYYY MMM Do, H:mm:ss';
  static DATE_FORMAT_YYYY_MM_D = 'YYYY MM Do, H:mm:ss';
  static DATE_FORMAT_DD_MM_YYYY = 'DD-MM-YYYY';

  static EVENT_DATE_FORMAT = 'YYYY MMM Do, H:mm:ss';
  static BET_TIME_FORMAT = 'YYYY MMM Do, H:mm:ss';
  static DATE_FORMAT = 'Do MMM YYYY';
  static DATE_FULL_MONTH_FORMAT = 'YYYY MMMM Do';
  static TIME_FORMAT = 'H:mm:ss';

  static BET_HISTORY_CSV_DATE_FORMAT = "ddd YYYY MMM Do HH_mm_ss";


  static MAX_EVENTS_ON_FAVOURITE_TAB = 19;

  static DEFAULT_DISPLAY_ID = 0;
  static MAIN_PERIODS_INDEX = 0;
  static SUB_PERIODS_INDEX = 1;
  static SUB_PERIODS_LEFT = 0;
  static SUB_PERIODS_RIGHT = 1;

  static LANG_BETTING_RULE_SUPPORT = {
    'en': 'en_US',
    'ru': 'ru_RU',
    'zh-cn': 'zh_CN',
    'zh-tw': 'zh_TW',
    'vi': 'vi_VN',
    'th': 'th_TH',
    'ko': 'ko_KR',
    'es': 'es_ES',
    'pt': 'pt_BR',
    'fi': 'fi_FI',
    'id': 'id_ID'
  };

  static BROKERAGE_BETTING_PHONE = "BROKERAGE_BETTING_PHONE";

  static OPTIN_STEPS = {
    WAITING_LOGIN: 1,
    COMPLETE_OPTIN: 2
  }

  static VERSION_NOT_SUPPORTED = {
    CHROME: 72,
    SAFARI: 14.1
  }

  static LEADERBOARD_PATH = "/leaderboard";
  static BETBUILDER_PATH = "/bet-builder";

  static IFRAME_MESSAGE = {
    IFRAME_LOADED: "isIframeLoaded",
    SELECTION_INFO: "selectionInfo",
    DP: 'dp',
    OPEN_CONTACT_US: 'contactUsTriggerNGC',
  }

  static DEFAULT_LOGO_DATES = {
    startDate: '2023-08-31T05:00:00Z',
    endDate: '2024-02-29T05:00:00Z'
  }

  static LOGO_DATES_ANNIVERSARY_KEY = 'logoDates';
  static KEYBOARD = {
    PIPE: '|'
  };

  static DP_CONTAINER = ['sportPageContainer'];

  static ATTENTION_MESSAGE = {
    ATTENTION: "Attention",
    LINE_CHANGED: "The odds changed during submission. Please resubmit and confirm your bet."
  }
  static ATTENTION_TYPE = {
    ERROR: "ERROR",
    WARNING: "WARNING"
  }

  static NEW_EURO_VIEW_URL = "/{locale}/standard/"

  static DP_ERROR = {
    NO_RECEIVE_DP_MESSAGE : "No receive dynamic parameter message"
  }
}


// WEBPACK FOOTER //
// ./src/app/common/Constants.js